import mixins from "../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    testing: false,
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      {
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "expired-page",
        "pageId": 104224,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "expired-page",
                "fieldId": "gjd101",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "Regulamente",
        "pageId": 237959,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#0f2967",
                  "title": "Regulamente",
                  "ordered": false,
                  "items": [
                    //Add latest at top
                    {
                      title: '',
                      text: `<a href="/ColgateKauflandSaga/Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate x Kaufland Saga Festival”, 01.07.2026-04.08.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhiteMoneyBack2026Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Nationala Colgate Max White Ultra Money Back”, 01.07.2026-31.08.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SummerJoy2026Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA Palmolive Summer Joy”, 01.06.2026-31.07.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotal2026Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Total Active Prevention - Spring”, 01.04.2026-31.05.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgatePalmoliveLidl2026Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Palmolive & Lidl”, 30.03.2026-24.05.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/WomenDay2026Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Nationala Women”, 14.02.2026-13.04.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWomenDay2026Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE WOMEN'S DAY - WHITENING”, 01.02.2026-31.03.2026</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhite2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Whitening - Christmas”, 01.11.2025-31.12.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateKaufland2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Kaufland Cashback”, 01.11.2025-09.12.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateLLDP2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Colgate La doi pasi”, 01.09.2025-30.09.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateLidl2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Colgate - Lidl”, 01.09.2025-05.10.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotalActivePrevention2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Colgate Total Active Prevention”, 06.08.2025-15.10.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/LidlBeauty2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Enjoy the Summer - Lidl”, 20.07.2025-20.08.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhiteMoneyBack2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Nationala Colgate Max White Ultra Money Back”, 15.06.2025-15.08.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SummerJoy2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA Palmolive Summer Joy”, 01.06.2025-31.07.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/CarrefourAniversar2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Carrefour Aniversar”, 07.05.2025-03.06.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/IngrijirePersonalaKaufland2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Enjoy the Spring - Kaufland”, 02.04.2025-03.06.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotal2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE TOTAL”, 01.04.2025-31.05.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Protexcashback2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Națională Protex Anti Flu”, 01.01.2025-28.02.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWomenDay2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE WOMEN'S DAY WHITENING”, 01.02.2024-31.03.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/WomenDay2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA NATIONALA DE ZIUA FEMEII”, 01.02.2024-31.03.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexHealthProtection2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „PROTEX HEALTH & PREVENTION”, 15.09.2023-15.11.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateSummer2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE ORAL HEALTH MONTH CARREFOUR HYPER & ONLINE”, 22.08.2023-30.09.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateUltra2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Nationala Colgate Max White Ultra Money Back”, 15.07.2023-31.08.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveExperentials2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „PALMOLIVE - EUFORIA SIMȚURILOR”, 01.05.2023-30.06.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Protex2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX ROMANIA”, 15.01.2023-15.03.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhiteningCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE WHITENING CARREFOUR HYPER & ONLINE”, 17.02.2022-23.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexCarrefourRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE IARNA PROTEX CARREFOUR HYPER & ONLINE”, 09.12.2021-09.01.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SpringCleaning2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Națională Spring Cleaning”, 01.03.2025-31.05.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexMoneyBack2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE NAȚIONALĂ ELMEX®- MONEY BACK”, 01.03.2025-31.05.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/WomenDay2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei "Campania Națională Ziua Femeii", 01.02.2025-31.03.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWomenDay2025Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei "Colgate Women's day - Whitening", 01.02.2025-31.03.2025</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhitening2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei "Colgate WHITENING", 30.10.2024-31.12.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Protex2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei "Campania Națională Protex Fall Essentials", 01.10.2024-30.11.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveChristmas2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei “Palmolive - Spiridușul vestimentației tale de sărbători”, 01.10.2024-30.11.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateOHMLDP2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE ORAL HEALTH MONTH LA DOI PASI”, 01.09.2024-30.09.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateOHM2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE ORAL HEALTH MONTH”, 15.08.2024-15.10.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveLifestyle2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA PALMOLIVE LIFESTYLE- CARREFOUR”, 31.07.2024-20.08.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexMoneyBack2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE NAȚIONALĂ ELMEX®- MONEY BACK”, 01.07.2024-30.09.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhiteMoneyBack2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Nationala Colgate Max White Ultra Money Back”, 15.06.2024-15.08.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SummerExperience2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA Palmolive Summer Experience”, 01.06.2024-31.08.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/CarrefourAniversar2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA CARREFOUR ANIVERSAR”, 22.05.2024-18.06.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateParkLakeRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate in Park Lake, 09.05.2024-20.05.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhiteningSelgros2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Whitening Selgros”, 03.05.2024-30.05.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotal2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Total”, 01.04.2024-31.05.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Springcleaning2024Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Națională Spring Cleaning”, 01.03.2024-30.04.2024</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Elmex2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Elmex Comerț Tradițional”, 01.10.2023-31.12.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Autumncleaning2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Națională Autumn Cleaning”, 01.10.2023-30.11.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateSeptember2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campanie Colgate Oral Health Month La Doi Pasi”, 05.09.2023-30.09.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateITRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campanie Colgate Oral Health Comert Traditional”, 01.09.2023-31.10.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateSummerKaufland2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campanie Colgate Oral Health Month Kaufland”, 17.08.2023-30.09.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Ladyspeedstick2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Carrefour Palmolive & Lady Speed Stick”, 08.08.2023-22.08.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveSummer2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Campania Națională Palmolive Summer Experience”, 27.06.2023-31.08.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhitening2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Whitening Comerț Tradițional”, 19.06.2023-19.08.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgatePalmolive2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE PALMOLİVE”, 03.05.2023-30.05.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexIT2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Elmex - Comerț Tradițional”, 01.05.2023-30.06.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveExperentials2023.pdf" target="_blank">Regulamentul oficial al Campaniei „Sarbatorim impreuna 22 ani de Carrefour”, 01.05.2023-30.06.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/AjaxAxion2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „AJAX & AXION SPRING CLEANING”, 01.03.2023-30.04.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Elmex-MB2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „ELMEX®- MONEY BACK”, 01.03.2023-31.05.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotal2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „Colgate Total Romania”, 01.03.2023-30.04.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateMaxAuchan2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „SARBATOAREA IUBIRII AUCHAN”, 08.02.2023-08.03.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateMax2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE WOMEN'S DAY CARREFOUR”, 10.02.2023-09.03.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Palmolive2023Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE ZIUA FEMEII PALMOLIVE NAȚIONAL”, 01.02.2023-31.03.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateCharcoalRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX ROMANIA”, 15.01.2023-15.03.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateCharcoalRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE & PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”, 15.12.2022-13.01.2023</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/AutumnCleaning2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE AUTUMN CLEANING AJAX & AXION ROMANIA”, 01.10.2022-15.12.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexSummerRomaniaRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX HEALTH AND PREVENTION”, 01.09.2022-30.11.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexAugust2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE elmex® Carrefour HYPER & ONLINE”, 25.08.2022-22.09.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateAugust2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE ORAL HEALTH MONTH CARREFOUR HYPER & ONLINE”, 25.08.2022-22.09.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexSummerCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX SUMMER CARREFOUR HYPER & ONLINE”, 11.08.2022-11.09.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Moneyback2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE NATIONALA MAX WHITE ULTRA - MONEY BACK”, 01.07.2022-31.08.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveSmoothies2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PALMOLIVE SMOOTHIES ROMANIA”, 01.07.2022-31.08.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/PalmoliveCarrefourJune2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PALMOLIVE SUMMER CARREFOUR HYPER & ONLINE”, 20.06.2022-20.07.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexCarrefourJuly2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE elmex® CARREFOUR HYPER & ONLINE”, 09.06.2022-09.07.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ActiveLifestyleMegaRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE ACTIVE LIFESTYLE PALMOLIVE & LADY SPEED STICK & MENNEN SPEED STICK MEGA IMAGE", 26.05.2022-26.06.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ActiveLifestyleCarrefourRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE ACTIVE LIFESTYLE PALMOLIVE & LADY SPEED STICK & MENNEN SPEED STICK CARREFOUR HYPER & ONLINE”, 12.05.2022-12.06.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ActiveLifestyleCoraRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE ACTIVE LIFESTYLE PALMOLIVE & LADY SPEED STICK & MENNEN SPEED STICK CORA HYPER & ONLINE”, 11.05.2022-11.06.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateCarrefour21AniRegulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE & CARREFOUR ANIVERSAR 21 DE ANI”, 28.04.2022-25.05.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexCharcoalCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”, 28.04.2022-28.05.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexCharcoalMega2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX CHARCOAL MEGA IMAGE”, 28.04.2022-25.05.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexCharcoalCora2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE PROTEX CHARCOAL CORA HYPER & ONLINE”, 27.04.2022-27.05.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SpringCleaningMega2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE SPRING CLEANING AJAX & AXION MEGA IMAGE”, 24.03.2022-24.04.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SpringCleaningCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”, 24.03.2022-24.04.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/SpringCleaningCora2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE SPRING CLEANING AJAX & AXION CORA HYPER & ONLINE”, 23.03.2022-23.04.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotalCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE TOTAL Carrefour HYPER & ONLINE”, 17.03.2022-17.04.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotalDM2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE TOTAL dm drogerie markt”, 09.03.2022-09.04.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/MegaImage2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE ZIUA FEMEII PALMOLIVE & LADY SPEED STICK MEGA IMAGE HYPER & ONLINE”, 24.02.2022-30.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Carrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE ZIUA FEMEII PALMOLIVE & LADY SPEED STICK CARREFOUR HYPER & ONLINE”, 24.02.2022-30.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateTotalMegaImage2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE TOTAL MEGA IMAGE”, 24.02.2022-24.03.2022</a>`
                    },//
                    {
                      title: '',
                      text: `<a href="/files/ElmexAuchanFeb2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „COLGATE WHITENING CARREFOUR HYPER & ONLINE”, 17.02.2022-23.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexAuchanFeb2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE elmex® AUCHAN HYPER & ONLINE”, 16.02.2022-16.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexMegaFeb2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE elmex® MEGA IMAGE SUPER & ONLINE”, 14.02.2022-14.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ElmexCarrefourFeb2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE elmex® CARREFOUR HYPER & ONLINE”, 10.02.2022-10.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/Auchan2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA ZIUA FEMEII PALMOLIVE & LADY SPEED STICK AUCHAN HYPER & ONLINE”, 09.02.2022-08.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateWhiteningAuchan2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA COLGATE WHITENING AUCHAN HYPER & ONLINE”, 09.02.2022-08.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateElixirCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE ELIXIR CARREFOUR HYPER & ONLINE”, 03.02.2022-03.03.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateEquityCarrefourJan2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE COLGATE EQUITY CARREFOUR HYPER & ONLINE”, 13.01.2022-13.02.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ProtexCarrefourJan2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIE HEALTH & PREVENTION PROTEX CARREFOUR HYPER & ONLINE”, 13.01.2022-13.02.2022</a>`
                    },
                    {
                      title: '',
                      text: `<a href="/files/ColgateElixirCarrefour2022Regulament.pdf" target="_blank">Regulamentul oficial al Campaniei „CAMPANIA COLGATE ELIXIR CARREFOUR HYPER & ONLINE”, 03.02.2022-03.03.2022</a>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      {
        "pageName": "castigatori",
        "pageId": 92742,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#0f2967",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    // {
                    //   title: ``,
                    //   text: `<a href="/ColgateElixirCarrefour2022/Castigatori" target="_blank">Castigatorii Campanei „CAMPANIA COLGATE ELIXIR CARREFOUR HYPER & ONLINE”, 03.02.2022-03.03.2022</a>`
                    // },
                    // {
                    //   title: ``,
                    //   text: `<a href="/ProtexCarrefourJan2022/Castigatori" target="_blank">Castigatorii Campanei „CAMPANIE HEALTH & PREVENTION PROTEX CARREFOUR HYPER & ONLINE”, 13.01.2022-13.02.2022</a>`
                    // },
                    // {
                    //   title: ``,
                    //   text: `<a href="/ColgateEquityCarrefourJan2022/Castigatori" target="_blank">Castigatorii Campanei „CAMPANIE COLGATE EQUITY CARREFOUR HYPER & ONLINE”, 13.01.2022-13.02.2022</a>`
                    // },
                    {
                      title: ``,
                      text: `<a href="/Protexcashback2025/castigatori" target="_blank">Castigatorii  „Campania Națională Protex Anti Flu”, 01.01.2025-28.02.2025</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/Elmex2023/castigatori" target="_blank">Castigatorii  „Elmex Comerț Tradițional”, 01.10.2023-31.12.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ElmexIT2023/castigatori" target="_blank">Castigatorii  „Elmex - Comerț Tradițional”, 01.05.2023-30.06.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/PalmoliveExperentials2023/castigatori" target="_blank">Castigatorii  „PALMOLIVE - EUFORIA SIMȚURILOR”, 01.05.2023-30.06.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgatePalmolive2023/castigatori" target="_blank">Castigatorii  „Sărbătorim împreună 22 ani de Carrefour”, 03.05.2023-30.05.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/AjaxAxion2023/castigatori" target="_blank">Castigatorii  „Ajax & Axion Spring Cleaning”, 01.03.2023-30.04.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateTotal2023/castigatori" target="_blank">Castigatorii  „Colgate Total Romania”, 01.03.2023-30.04.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/Palmolive2023/castigatori" target="_blank">Castigatorii  „CAMPANIE ZIUA FEMEII PALMOLIVE NAȚIONAL”, 01.02.2023-31.03.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/Protex2023/castigatori" target="_blank">Castigatorii  „CAMPANIE PROTEX ROMANIA”, 15.01.2023-15.03.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateCharcoal/castigatori" target="_blank">Castigatorii  „COLGATE & PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”, 15.12.2022-13.01.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateMax2023/castigatori" target="_blank">Castigatorii  „COLGATE WOMEN'S DAY CARREFOUR”, 10.02.2023-09.03.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateMaxAuchan2023/castigatori" target="_blank">Castigatorii  „SARBATOAREA IUBIRII AUCHAN”, 08.02.2023-08.03.2023</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/AutumnCleaning2022/castigatori" target="_blank">Castigatorii  „CAMPANIE AUTUMN CLEANING AJAX & AXION ROMANIA”, 01.10.2022-15.12.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ProtexSummerRomania/castigatori" target="_blank">Castigatorii  „CAMPANIE PROTEX HEALTH AND PREVENTION”, 01.09.2022-30.11.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateAugust2022/castigatori" target="_blank">Castigatorii  „CAMPANIE COLGATE ORAL HEALTH MONTH CARREFOUR HYPER & ONLINE”, 25.08.2022-22.09.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ElmexAugust2022/castigatori" target="_blank">Castigatorii „CAMPANIE elmex® Carrefour HYPER & ONLINE, 25.08.2022-22.09.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ElmexCarrefourJuly2022/castigatori" target="_blank">Castigatorii „CAMPANIE elmex® CARREFOUR HYPER & ONLINE”, 09.06.2022-09.07.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ActiveLifestyleMega/castigatori" target="_blank">Castigatorii „CAMPANIE ACTIVE LIFESTYLE PALMOLIVE & LADY SPEED STICK & MENNEN SPEED STICK MEGA IMAGE”, 26.05.2022-26.06.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ProtexCharcoalCarrefour2022/castigatori" target="_blank">Castigatorii „CAMPANIE PROTEX CHARCOAL CARREFOUR HYPER & ONLINE”, 28.04.2022-28.05.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ActiveLifestyleCarrefour/castigatori" target="_blank">Castigatorii „CAMPANIE ACTIVE LIFESTYLE PALMOLIVE & LADY SPEED STICK & MENNEN SPEED STICK CARREFOUR HYPER & ONLINE”, 12.05.2022-12.06.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateCarrefour21Ani/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE & CARREFOUR ANIVERSAR 21 DE ANI”, 28.04.2022-25.05.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ProtexCharcoalCora2022/castigatori" target="_blank">Castigatorii „CAMPANIE PROTEX CHARCOAL CORA HYPER & ONLINE”, 27.04.2022-27.05.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ProtexCharcoalMega2022/castigatori" target="_blank">Castigatorii „CAMPANIE PROTEX CHARCOAL MEGA IMAGE”, 28.04.2022-25.05.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ActiveLifestyleCora/castigatori" target="_blank">Castigatorii „CAMPANIE ACTIVE LIFESTYLE PALMOLIVE & LADY SPEED STICK & MENNEN SPEED STICK CORA HYPER & ONLINE”, 11.05.2022-11.06.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/SpringCleaningCarrefour2022/castigatori" target="_blank">Castigatorii „CAMPANIE SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”, 24.03.2022-24.04.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/SpringCleaningMega2022/castigatori" target="_blank">Castigatorii „CAMPANIE SPRING CLEANING AJAX & AXION MEGA IMAGE”, 24.03.2022-24.04.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/SpringCleaningCora2022/castigatori" target="_blank">Castigatorii „CAMPANIE SPRING CLEANING AJAX & AXION CORA HYPER & ONLINE”, 23.03.2022-23.04.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/Carrefour2022/castigatori" target="_blank">Castigatorii „CAMPANIE ZIUA FEMEII PALMOLIVE & LADY SPEED STICK CARREFOUR HYPER & ONLINE”, 24.02.2022-24.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/MegaImage2022/castigatori" target="_blank">Castigatorii „CAMPANIE ZIUA FEMEII PALMOLIVE & LADY SPEED STICK MEGA IMAGE HYPER & ONLINE”, 24.02.2022-30.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateTotalDM2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE TOTAL dm”, 09.03.2022-09.04.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateTotalCarrefour2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE TOTAL Carrefour HYPER & ONLINE”, 17.03.2022-17.04.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateTotalMegaImage2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE TOTAL MEGA IMAGE”, 24.02.2022-30.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateWhiteningCarrefour2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE WHITENING CARREFOUR HYPER & ONLINE”, 17.02.2022-23.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ElmexMegaFeb2022/castigatori" target="_blank">Castigatorii „CAMPANIE elmex® MEGA IMAGE”, 14.02.2022-14.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateElixirCarrefour2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE ELIXIR CARREFOUR HYPER & ONLINE”, 03.02.2022-03.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ElmexAuchanFeb2022/castigatori" target="_blank">Castigatorii „CAMPANIE elmex® AUCHAN”, 16.02.2022-16.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ElmexCarrefourFeb2022/castigatori" target="_blank">Castigatorii „CAMPANIE elmex® CARREFOUR”, 10.02.2022-10.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateWhiteningAuchan2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE WHITENING AUCHAN HYPER & ONLINE”, 09.02.2022-08.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/Auchan2022/castigatori" target="_blank">Castigatorii „CAMPANIE ZIUA FEMEII PALMOLIVE & LADY SPEED STICK AUCHAN HYPER & ONLINE”, 09.02.2022-08.03.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ColgateEquityCarrefourJan2022/castigatori" target="_blank">Castigatorii „CAMPANIE COLGATE EQUITY CARREFOUR HYPER & ONLINE”, 13.01.2022-13.02.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ProtexCarrefourJan2022/castigatori" target="_blank">Castigatorii Campanei „HEALTH & PREVENTION PROTEX CARREFOUR HYPER & ONLINE”, 13.01.2022-13.02.2022</a>`
                    },
                    {
                      title: ``,
                      text: `<a href="/ProtexCarrefour/castigatori" target="_blank">Castigatorii Campanei „„CAMPANIE IARNA PROTEX CARREFOUR HYPER & ONLINE”, 09.12.2021-09.01.2022</a>`
                    }

                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // terms
        pageName: 'ColgateKauflandSaga/Regulament.pdf',
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12,
              marginBottom: '50px'
            },
            fields: [
              {
                fieldType: 'pdf-viewer',
                fieldId: 'vabd69',
                properties: {
                  grid: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    columns: '12'
                  },
                  link: 'https://jolt-assets.s3.eu-central-1.amazonaws.com/template/promocolgatepalmolive-ro/ColgateKauflandSaga/terms.pdf'
                }
              }
            ]
          }
        ]
      },
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 94,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Castigatori",
              "url": "/castigatori",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulamente",
              "url": "/Regulamente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Colgate" },
          {
            "name": "description",
            "content": `Colgate Palmolive`
          },
          {
            "name": "keywords",
            "content": 'Colgate Palmolive'
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "Neutrogena", "link": "https://www.neutrogena.ro/home" },
          { "name": "Johnson's Baby", "link": "https://www.johnsonsbaby.ro/" },
          { "name": "Listerine", "link": "https://www.listerine.ro/" },
          { "name": "OB", "link": "https://www.tampoane-ob.ro/" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ]
      }
    },
    "campaignId": "",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "promocolgatepalmolive"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: '',
  formData: new FormData(),
  campaignEndDate: '2020-12`- 15',
  showNavLinks: true,
  excludedPages: []
}
